import Vue    from 'vue'
import Router from 'vue-router'

import Home          from '@/views/Home.vue'
import LogsDashboard from '@/views/LogsDashboard.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/logs',
      name: 'LogsDashboard',
      component: LogsDashboard
    }
  ]
})
